export const isDev = true;
export const isStage = true;

export const showBoclipsSearch = false;

export const wordpressURL = isDev
  ? process.env.REACT_APP_STAGING_POLICY_URL
  : process.env.REACT_APP_PRODUCTION_POLICY_URL;

export const amplitudeKey = isDev
  ? process.env.REACT_APP_AMPLITUDE_DEV
  : process.env.REACT_APP_AMPLITUDE_PROD;

export const currentEnv = isDev && !isStage ? "dev-" : isStage ? "staging-" : "";

export const staticsite = "staging.";

const engineDefaults = {
  Google: { count: 10, offset: 10, maxResults: 20 },
  Bing: { count: 21, offset: 21, maxResults: 21 },
};

const resolveConfig = (engine, overrides = {}) => ({
  engine,
  ...engineDefaults[engine],
  ...overrides,
});

export const searchConfig = {
  categories: resolveConfig("Bing"),
  mediaBias: resolveConfig("Bing"),
  partnerPublishers: resolveConfig("Bing"),
  peerReviewed: resolveConfig("Bing"),
  books: resolveConfig("Bing", { count: 10, offset: 10, maxResults: 10 }),
  wiki: resolveConfig("Bing"),
  academia: resolveConfig("Bing"),
  misinformation: resolveConfig("Bing"),
  pulse: resolveConfig("Bing"),
  boclips: resolveConfig("Bing"),
};

export const currentSearchEngine = searchConfig.categories.engine;

export const searchEngineOffsets = {
  "Academia": searchConfig.academia.offset,
  "Bing": engineDefaults.Bing.offset,
  "Books": searchConfig.books.offset,
  "Wiki": searchConfig.wiki.offset,
  "Google": engineDefaults.Google.offset,
  "Pulse": searchConfig.pulse.offset,
  "Default": searchConfig.categories.offset,
};

export const searchEngineCounts = {
  "Academia": searchConfig.academia.count,
  "Bing": engineDefaults.Bing.count,
  "Books": searchConfig.books.count,
  "Wiki": searchConfig.wiki.count,
  "Google": engineDefaults.Google.count,
  "Pulse": searchConfig.pulse.count,
  "Default": searchConfig.categories.count,
};
